<template>
  <div>
    <MTop title="小梅花分类列表" />
    <div>
      <ul class="mobile-s-t">
        <li
          :class="index == id ?'isActive':''"
          @click="checkType($event,item.id)"
          v-for="(item,index) in titleArray"
          :id="index"
          :key="item.id"
        >{{item.name}}</li>
      </ul>
    </div>
    <div class="mob_list">
      <!-- 单视频 -->
      <ul v-if="videoList.length !== 0">
        <li
          @click="selectDetail(item.id)"
          class="top-li"
          v-for="(item,index) in videoList"
          :key="item.id"
        >
          <div class="li-img">
            <el-image fit="cover" :src="item.fileLocation"></el-image>
            <!-- <div
              :class="[linum,index == 0|| index == 1 || index == 2?bgYellow:'bg-gary']"
            >{{index + 1}}</div>-->
          </div>
          <div class="li-text">
            <h3 class="red">{{item.fileName}}</h3>
            <div class="f12">相关人物：{{item.personName}}</div>
            <div class="f12">上传人：{{item.createUser}}</div>
            <div
              class="text-color f12"
            >类别：{{item.videoType == 1 ?'成片库':'素材库'}} / 格式：{{item.fileType}}</div>
            <div class="text-color f12">时长：{{item.filePlayTime}}</div>
          </div>
        </li>
      </ul>
      <div v-if="videoList.length == 0" style="padding:30px;" class="tac">暂无数据</div>
    </div>
    <!-- 加载更多 -->
    <div v-if="isMoreLoad && videoList.length !== 0" class="padding-20 tac">
      <el-button @click="loadingMore" size="mini">{{loadMoreName}}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      loadMoreName: "加载更多",
      isMoreLoad: true,
      titleArray: [
        { id: 0, name: "京昆组", isShow: false },
        { id: 1, name: "地方戏组", isShow: false },
        { id: 2, name: "集体节目", isShow: false }
      ],
      id: 0,
      roleId: "",
      flowerCategory: "京昆组",
      videoList: [],
      page: 1,
      total: 0, // 分页总数
      limit: 10
    };
  },
  methods: {
    loadingMore() {
      if (this.page < this.total / 10) {
        this.page++;
        this.getFlowerList();
        this.$store.state.currentpage = this.page
      } else {
        this.$layer.toast({
          icon: "icon-check", // 图标clssName 如果为空 toast位置位于下方,否则居中
          content: "全部加载完毕",
          time: 1000 // 自动消失时间 toast类型默认消失时间为2000毫秒
        });
        this.isMoreLoad = false;
      }
    },
    getIsShow(roleid) {
      for (var i = 0; i < this.titleArray.length; i++) {
        if (roleid == 6) {
          this.titleArray[i].isShow = true;
          this.flowerCategory = "京昆组";
        } else if (roleid == 7) {
          this.titleArray[1].isShow = true;
          this.titleArray[2].isShow = true;

          // 地方戏组
          this.flowerCategory = "地方戏组";
          this.activeId = 1;
        } else if (roleid == 8) {
          this.titleArray[0].isShow = true;
          this.titleArray[2].isShow = true;
          // 京昆组
          this.flowerCategory = "京昆组";
        } else if (roleid == 9) {
          this.titleArray[2].isShow = true;
          // 集体节目
          this.flowerCategory = "集体节目";
          this.activeId = 2;
        }
      }
     /*  if(this.$store.state.tabname){
      this.flowerCategory = this.$store.state.tabname
    } */
      // this.getFlowerList();
      console.log(this.titleArray);
    },
    getFlowerList: async function() {
      // 京昆组或地方戏组
      var res = await this.$http.get(
        `/v1/videoInfo/getPrizeList?page=${this.page}&category=${this.flowerCategory}`
      );
      var { code, data, message, total } = res.data;
      if (code == 0) {
        this.videoList = data;
        this.total = total;
        // document.querySelector('.v-top-title').scrollIntoView(true)
      } else {
        this.$message.error(message);
      }
    },
    // ---选择类别
    checkType: function(e, id) {
      this.page = 1;
      this.id = e.target.id;
      this.$store.state.tabactiveid = this.id
      /* if (id == 0) {
        this.flowerCategory = "";
        this.getFlowerList();

        return false;
      } */
      if (id == 0) {
        // 京昆组
        this.flowerCategory = "京昆组";
        this.getFlowerList();
        this.$store.state.tabname = "京昆组";
        return false;
      }
      if (id == 1) {
        // 地方戏组
        this.flowerCategory = "地方戏组";
        this.getFlowerList();
        this.$store.state.tabname = "地方戏组";

        return false;
      }
      if (id == 2) {
        // 集体节目
        this.flowerCategory = "集体节目";
        this.getFlowerList();
        this.$store.state.tabname = "集体节目";

        return false;
      }
    },
    selectDetail: async function(id) {
      var res = await this.$http.post(`/v1/videoInfo/videoStatus?id=${id}`);
      var { code, message, data } = res.data;
      if (code == 0) {
        this.$router.push({
          path: "/mobvideodetail",
          query: {
            id: id,
            status: 0
          }
        });
      } else {
        this.$layer.toast({
          icon: "icon-check", // 图标clssName 如果为空 toast位置位于下方,否则居中
          content: message,
          time: 1000 // 自动消失时间 toast类型默认消失时间为2000毫秒
        });
      }
    }
    /*   checkType: function(e) {
      console.log(e);
      this.id = e.target.id;
      if (this.id == 0) {
        // 全部
        this.videoTypeId = "";
        this.$store.commit("changeTypeId", "");
      } else if (this.id == 1) {
        // 成片
        this.videoTypeId = 1;
        this.$store.commit("changeTypeId", 1);
      } else {
        // 素材
        this.videoTypeId = 0;
        this.$store.commit("changeTypeId", 0);
      }
    } */
  },
  mounted() {
    // this.getFlowerList();
    /* if(this.$store.state.tabname){
      this.flowerCategory = this.$store.state.tabname
    }
    this.roleId = this.$store.state.userInfo.roleid;
    this.getIsShow(this.roleId); */
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (
        vm.$store.state.userInfo.roleid != "6" &&
        vm.$store.state.userInfo.roleid != "7" &&
        vm.$store.state.userInfo.roleid != "8" &&
        vm.$store.state.userInfo.roleid != "9"
      ) {
        vm.$router.push({ path: "/home" });
      }
    
      // console.log(from)
      if(from.path == '/mobvideodetail'){
        console.log('mobiledetail222222222')
        vm.roleId = vm.$store.state.userInfo.roleid;

        vm.getIsShow(vm.roleId); 
        vm.page = vm.$store.state.currentpage
        vm.flowerCategory = vm.$store.state.tabname
        vm.id =  vm.$store.state.tabactiveid
           
        vm.getFlowerList()
      
      }else{
       vm.$store.state.currentpage = 1
        vm.roleId = vm.$store.state.userInfo.roleid;
        vm.getIsShow(vm.roleId);
        vm.getFlowerList()

      }
    });
  }
};
</script>

<style lang="scss">
.mobile-s-t {
  width: 100%;
  // padding:0 20px ;
  background-color: #fff;
  // border-bottom: 1px solid #ccc;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.mobile-s-t li {
  float: left;
  padding: 10px;
  font-size: 16px;
  // height: 100%;
  // padding: 20px ;
}
.isActive {
  border-bottom: 2px solid #00aaff;
  color: #00aaff;
}
.mob_list {
  background-color: #fff;
  margin-top: 20px;
  .top-li {
    display: flex;
    flex-direction: row;
    padding: 20px 10px;
    border-bottom: 1px solid #dddddd;
    margin: 0px 10px;
    .li-img {
      position: relative;
      .li-num {
        width: 30px;
        height: 26px;
        border-radius: 5px 0 5px 0;
        // background-color: #f5a623;
        // background-color: #c1c7ce;

        left: 0px;
        top: 0px;
        position: absolute;
        text-align: center;
        color: #fff;
        font-size: 20px;
      }
    }
    .el-image {
      width: 135px;
      height: 96px;
      border-radius: 5px;
    }
    .li-text {
      padding: 0 10px;
      h3 {
        text-align: left;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
  }
  .topTab {
    justify-content: space-around;
    border-bottom: 1px solid #eaeaea;
    // padding: 0px 20px;
    text-align: center;

    .ll {
      width: 100%;
      padding: 10px 20px;
      cursor: pointer;
      font-size: 14px;
      color: #555;
    }
    .ll:first-child {
      background-color: #00aaff;
      color: #fff;
      font-size: 16px;
    }
  }
  // 视频集
  .list-gather {
    .top-li {
      display: flex;
      flex-direction: row;
      padding: 20px 10px;
      border-bottom: 1px solid #dddddd;
      margin: 0px 10px;
      .li-img {
        box-shadow: -10px 10px 2px #d7d7d7;
        border-radius: 5px;
        position: relative;
        .li-num {
          width: 30px;
          height: 26px;
          border-radius: 5px 0 5px 0;
          // background-color: #f5a623;
          // background-color: #c1c7ce;

          left: 0px;
          top: 0px;
          position: absolute;
          text-align: center;
          color: #fff;
          font-size: 20px;
        }
      }
      .el-image {
        width: 135px;
        height: 96px;
        border-radius: 5px;
        box-shadow: -5px 5px 1px #969696;
      }
      .li-text {
        padding: 0 10px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/flowpage.vue